import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import {ComponentsModule} from "../../components/components.module";
import {PopoverUnassociatedProgressPage} from "./popover-unassociated-progress";
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  declarations: [
    PopoverUnassociatedProgressPage,
  ],
  imports: [
    ComponentsModule,
    IonicPageModule.forChild(PopoverUnassociatedProgressPage),
    TranslateModule.forChild()
  ],
})
export class PopoverUnassociatedProgressPageModule {}



// WEBPACK FOOTER //
// ./src/pages/popover-unassociated-progress/popover-unassociated-progress.module.ts